import React from 'react'

const InventoryItemDetails = () => {
  return (
    <div>InventoryItemDetails</div>
  )
}

export default InventoryItemDetails